import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  CardActions, 
  Button, 
  TextField, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip
} from '@mui/material';
import { 
  Add as AddIcon, 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Language as LanguageIcon,
  CurrencyExchange as CurrencyIcon,
  Business as BusinessIcon,
  Category as CategoryIcon
} from '@mui/icons-material';
import { useSystem } from '../context/SystemContext';

const MasterDataManagement = () => {
  const { masterData, loadMasterData } = useSystem();
  const [selectedCategory, setSelectedCategory] = useState('units');
  const [openDialog, setOpenDialog] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    loadMasterData();
  }, [loadMasterData]);

  const categories = [
    { key: 'units', label: 'Birimler', icon: <CategoryIcon /> },
    { key: 'countries', label: 'Ülkeler', icon: <LanguageIcon /> },
    { key: 'cities', label: 'Şehirler', icon: <BusinessIcon /> },
    { key: 'currencies', label: 'Para Birimleri', icon: <CurrencyIcon /> },
    { key: 'vehicleAttributes', label: 'Araç Özellikleri', icon: <CategoryIcon /> },
    { key: 'languages', label: 'Diller', icon: <LanguageIcon /> },
    { key: 'firmTypes', label: 'Firma Türleri', icon: <BusinessIcon /> },
    { key: 'workOrderTypes', label: 'İş Emri Türleri', icon: <CategoryIcon /> }
  ];

  const handleAdd = () => {
    setEditingItem(null);
    setFormData({});
    setOpenDialog(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData(item);
    setOpenDialog(true);
  };

  const handleDelete = (id) => {
    // TODO: Implement delete functionality
    console.log('Delete item:', id);
  };

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Save item:', formData);
    setOpenDialog(false);
  };

  const getCurrentData = () => {
    return masterData[selectedCategory] || [];
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Master Data Yönetimi
      </Typography>
      
      <Grid container spacing={3}>
        {/* Category Selection */}
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Kategoriler
            </Typography>
            {categories.map((category) => (
              <Card 
                key={category.key}
                sx={{ 
                  mb: 1, 
                  cursor: 'pointer',
                  bgcolor: selectedCategory === category.key ? 'primary.light' : 'background.paper'
                }}
                onClick={() => setSelectedCategory(category.key)}
              >
                <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {category.icon}
                    <Typography variant="body2">
                      {category.label}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Paper>
        </Grid>

        {/* Data Table */}
        <Grid item xs={12} md={9}>
          <Paper sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                {categories.find(c => c.key === selectedCategory)?.label}
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAdd}
              >
                Yeni Ekle
              </Button>
            </Box>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Ad</TableCell>
                    <TableCell>Kod</TableCell>
                    <TableCell>Durum</TableCell>
                    <TableCell>İşlemler</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getCurrentData().map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.code}</TableCell>
                      <TableCell>
                        <Chip 
                          label={item.active ? 'Aktif' : 'Pasif'} 
                          color={item.active ? 'success' : 'default'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleEdit(item)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleDelete(item.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {editingItem ? 'Düzenle' : 'Yeni Ekle'}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Ad"
            value={formData.name || ''}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Kod"
            value={formData.code || ''}
            onChange={(e) => setFormData({ ...formData, code: e.target.value })}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>İptal</Button>
          <Button onClick={handleSave} variant="contained">Kaydet</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MasterDataManagement;
